// Function to set favicon dynamically
export const setFavicon = (url: string) => {
  const link: any =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = url;
  document.getElementsByTagName("head")[0].appendChild(link);
};
// Function to set document title dynamically
export const setDocumentTitle = (title: string) => {
  document.title = title;
};

// Function to set meta description dynamically
export const setMetaDescription = (description: string) => {
  let meta: any =
    document.querySelector("meta[name='description']") ||
    document.createElement("meta");
  meta.name = "description";
  meta.content = description;
  document.getElementsByTagName("head")[0].appendChild(meta);
};

// Function to check if current URL is production
export const isProductionUrl = (): boolean => {
  const currentHost = window.location.hostname;
  const productionHosts = [
    "cc.playereliteapps.us",
    "nexuscc.pedls.com.au",
    "cc.pedls.com.au",
  ];

  return productionHosts.includes(currentHost);
};
